module.exports = __webpack_public_path__ + "static/img/page_24.a0ade4db.png";